import React from "react";
import { Box } from "@chakra-ui/react"


const ErrorBox = ({ error, width }) => {
    return(
        <Box textAlign="left" m="2px auto 0px auto" color="error" width={width} fontSize="12px"> {error} </Box>
    )
}

export default ErrorBox;